import {SearchService} from './../../../../services/search.service';
import {UserService} from './../../../../services/user.service';
import {TranslateService} from '@ngx-translate/core';
import {Customer} from './../../../../models/customer';
import {Component, DoCheck, OnInit} from '@angular/core';
import {ProductsService} from '../../../../../shared/services/products.service';
import {Router} from '@angular/router';
import {environment} from "../../../../../../environments/environment";


@Component({
  selector: 'app-topbar',
  templateUrl: './topbar-one.component.html',
  styleUrls: ['./topbar-one.component.scss'],
  providers: [UserService]
})
export class TopbarOneComponent implements OnInit, DoCheck {
  customer: Customer;
  name = '';
  nameMulticlient = environment.general.nameMultiClient
  public isOpen: boolean = false;

  constructor(public productsService: ProductsService, 
    private translate: TranslateService,
    private router: Router,
    private userService: UserService,
    private searchService: SearchService) { }
  
  toggleMenu() {
    this.isOpen = !this.isOpen;
  }
  
    ngDoCheck(): void {
      const identity = JSON.parse(localStorage.getItem('login'));
        if (identity !== 'undefined' && identity != null) {
            this.customer = identity.customer;  
            this.name = this.customer.name;          
        } else {
            this.customer = null; 
           this.getCustomerName();          
        }
    }

  ngOnInit() {}



  getCustomerName() {
    let myAccount;
    this.translate.get('my-account').subscribe(
      res => {
          myAccount = res;
      }
    );
    this.name = (this.customer) ? this.customer.name : myAccount;
    return this.name;
  }

  logout() {        
    localStorage.removeItem('login');
    localStorage.setItem('token', null);
    localStorage.removeItem('token-expiration');
    localStorage.setItem('logout', 'true');
    this.searchService.vaciarProductoABuscar();
    this.customer = null;
    this.getCustomerName();
    this.router.navigate(['/']);
  }

}
